/**
 * Converts a string to a number if compatible, otherwise returns the string as is.
 * @param value The string value to convert.
 */
export const asNumberOrString = (value: string) => {

	let numValue: number;
	if (!isNaN((numValue = parseInt(value)))) {

		return numValue;
	}
	else {

		return value;
	}
}